<template>
  <div class="nav-bar-container">
    <router-view/>
    <!-- 底部导航栏 -->
    <div class="nav-bar">
      <div class="nav-items">
        <div
            v-for="item in navItems"
            :key="item.path"
            class="nav-item"
            :class="{ active: activeIndex === item.path }"
            @click="handleSelect(item.path)"
        >
          <el-icon class="nav-icon">
            <template v-if="activeIndex === item.path">
              <svg width="24px" height="24px" fill="currentColor"> <!-- 修复svg尺寸过大问题 -->
                <use xlink:href="../resource/pear1.svg#icon"/>
              </svg>
            </template>
            <component :is="item.icon" v-else/>
          </el-icon>
          <div class="nav-text">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import {computed, onMounted, onUnmounted, ref, nextTick} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {HomeFilled, User} from '@element-plus/icons-vue';
import travel from '../resource/pear2Svg.vue';

const route = useRoute();
const router = useRouter();

// 导航项配置
const navItems = ref([
  {path: '/Main', title: '首页', icon: HomeFilled},
  {path: '/Order', title: '下单', icon: travel},
  {path: '/MyPage', title: '我的', icon: User},
]);

// 当前激活的路由
const activeIndex = computed(() => {
  const currentPath = route.path;
  return currentPath === '/' ? '/Main' : currentPath;
});

// 切换页面并记录点击状态
const handleSelect = (path) => {
  router.push(path);
};

// ---------------------- 5+ App 物理返回键修复逻辑 ----------------------
let backListener = null;
const isHandlingBack = ref(false);
const isPlusReady = ref(false); // 标记plus是否就绪

// 等待plus就绪的工具函数
const waitPlusReady = () => {
  return new Promise((resolve) => {
    if (window.plus) {
      isPlusReady.value = true;
      resolve();
    } else {
      document.addEventListener('plusready', () => {
        isPlusReady.value = true;
        resolve();
      }, { once: true }); // 只监听一次
    }
  });
};

// 处理物理返回键（核心修复）
const handleBackButton = () => {
  if (isHandlingBack.value) return;
  isHandlingBack.value = true;

  nextTick(() => {
    // 可靠的历史记录判断：通过路由的matched长度和历史栈长度判断
    const routes = router.getRoutes();
    const currentRouteDepth = route.matched.length; // 当前路由嵌套深度
    const historyLength = window.history.length; // 浏览器历史栈长度

    // 逻辑：如果有上一页（历史栈长度>1 或 路由深度>1），则返回上一页；否则退出
    if (historyLength > 1 || currentRouteDepth > 1) {
      router.go(-1);
    } else {
      // 二次确认退出（可选，提升用户体验）
      plus.nativeUI.confirm('确定要退出应用吗？', (e) => {
        if (e.index === 0) {
          plus.runtime.quit();
        }
      }, { title: '提示', buttons: ['确定', '取消'] });
    }

    setTimeout(() => {
      isHandlingBack.value = false;
    }, 300);
  });
};

// 注册返回键监听
const setupBackListener = async () => {
  await waitPlusReady(); // 确保plus就绪后再注册

  // 先移除已有监听（避免重复绑定）
  if (backListener) {
    plus.key.removeEventListener('backbutton', backListener);
  }

  // 注册新监听
  backListener = plus.key.addEventListener('backbutton', handleBackButton);
};

// 移除监听
const removeBackListener = () => {
  if (isPlusReady.value && backListener) {
    plus.key.removeEventListener('backbutton', backListener);
    backListener = null;
  }
};

// 组件挂载时注册监听
onMounted(() => {
  setupBackListener();
});

// 组件卸载时移除监听
onUnmounted(() => {
  removeBackListener();
});
/* eslint-enable */
</script>

<style scoped>
body, html {
  margin: 0;
  padding: 0;
}

.nav-bar-container {
  min-height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  padding-bottom: 7vh;
}

.nav-icon {
  width: 24px;
  height: 24px;
  font-size: 20px;
  margin-bottom: 4px;
}

.nav-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 7vh;
  border-top: 1px solid #eee;
  background-color: #EEDC82;
  z-index: 1000;
}

.nav-items {
  display: flex;
  width: 100%;
  height: 100%;
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #666;
}

.nav-item.active {
  color: #409eff;
}

.nav-text {
  font-size: 18px;
}
</style>